module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/event-badge-16cc7252d5fbd1ff3d79f1a7aa259a86.svg";